import { __decorate } from "tslib";
import { DebugLogService } from './DebugLogService';
import { provide } from '@/inversify.config';
export const ColumnFreezeServiceSymbol = Symbol.for('ColumnFreezeService');
// SORT_SEQ_NUM
let ColumnFreezeService = class ColumnFreezeService extends DebugLogService {
    constructor() {
        super(...arguments);
        this.eventName = 'SpaceDetail:ExcelGrid:Freeze';
        this.debug = false;
        this.columnConfig = null;
        this.onFreezeColumn = null;
    }
    clearSelected() {
        this.$log('清空选中列');
        this.columnConfig = null;
    }
    setSelected(config) {
        this.$log('选中列: ', config);
        this.columnConfig = config;
    }
    destroy() {
        this.clearSelected();
        this.onFreezeColumn = null;
    }
};
ColumnFreezeService = __decorate([
    provide(ColumnFreezeServiceSymbol)
], ColumnFreezeService);
export { ColumnFreezeService };
